var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"visible":_vm.centerDialogVisible,"top":"20vh","width":"25%"},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"qr-img",attrs:{"src":_vm.QrImgUrl}}),_c('div',{staticClass:"tip"},[_vm._v("微信扫码，布置课前预习、课后复习任务、查看作业测评报告")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }